import { render } from "./UllageDetails.vue?vue&type=template&id=2144c4a7"
import script from "./UllageDetails.vue?vue&type=script&lang=js"
export * from "./UllageDetails.vue?vue&type=script&lang=js"

import "./UllageDetails.vue?vue&type=style&index=0&id=2144c4a7&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__